import { render } from "./SingleQuestionDate.vue?vue&type=template&id=534b44c6"
import script from "./SingleQuestionDate.vue?vue&type=script&lang=js"
export * from "./SingleQuestionDate.vue?vue&type=script&lang=js"

import "./SingleQuestionDate.vue?vue&type=style&index=0&id=534b44c6&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__